module.exports = __webpack_public_path__ + "img/document-bottom-img1.13b243b5.png";